if (!customElements.get("facet-filters-form")) {
  class FacetFiltersForm extends HTMLElement {
    constructor() {
      super();

      this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 500);

      this.querySelector("form").addEventListener(
        "input",
        this.debouncedOnSubmit.bind(this)
      );

      const facetWrapper = this.querySelector("#FacetsWrapperDesktop");
      if (facetWrapper) facetWrapper.addEventListener("keyup", onKeyUpEscape);
    }

    static setListeners() {
      const onHistoryChange = (event) => {
        const searchParams = event.state
          ? event.state.searchParams
          : FacetFiltersForm.searchParamsInitial;
        if (searchParams === FacetFiltersForm.searchParamsPrev) return;
        FacetFiltersForm.renderPage(searchParams, null, false);
      };
      window.addEventListener("popstate", onHistoryChange);
    }

    static toggleActiveFacets(disable = true) {
      document.querySelectorAll(".js-facet-remove").forEach((element) => {
        element.classList.toggle("disabled", disable);
      });
    }

    static renderPage(searchParams, event, updateURLHash = true) {
      FacetFiltersForm.searchParamsPrev = searchParams;
      const sections = FacetFiltersForm.getSections();
      const countContainer = document.querySelectorAll(
        "[data-facets-product-count-mobile]"
      );
      const countContainerDesktop = document.querySelectorAll(
        "[data-facets-product-count-desktop]"
      );
      document
        .getElementById("ProductGridContainer")
        .querySelector(".collection")
        .classList.add("loading");

      countContainer.forEach((element) => {
        element.classList.add("loading");
      });

      countContainerDesktop.forEach((element) => {
        element.classList.add("loading");
      });

      sections.forEach((section) => {
        const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
        const filterDataUrl = (element) => element.url === url;

        FacetFiltersForm.filterData.some(filterDataUrl)
          ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
          : FacetFiltersForm.renderSectionFromFetch(url, event);
      });

      if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
    }

    static renderSectionFromFetch(url, event) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;
          FacetFiltersForm.filterData = [
            ...FacetFiltersForm.filterData,
            { html, url },
          ];
          FacetFiltersForm.renderFilters(html, event);
          FacetFiltersForm.renderProductGridContainer(html);
          FacetFiltersForm.renderProductCount(html);
        });
    }

    static renderSectionFromCache(filterDataUrl, event) {
      const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
      FacetFiltersForm.renderFilters(html, event);
      FacetFiltersForm.renderProductGridContainer(html);
      FacetFiltersForm.renderProductCount(html);
    }

    static renderProductGridContainer(html) {
      document.getElementById("ProductGridContainer").innerHTML =
        new DOMParser()
          .parseFromString(html, "text/html")
          .getElementById("ProductGridContainer").innerHTML;
    }

    static renderProductCount(html) {
      const count = new DOMParser()
        .parseFromString(html, "text/html")
        .getElementById("ProductCount").innerHTML;

      const container = document.querySelectorAll(
        "[data-facets-product-count-mobile]"
      );
      const containerDesktop = document.querySelectorAll(
        "[data-facets-product-count-desktop]"
      );

      container.forEach((element) => {
        element.innerHTML = count;
        element.classList.remove("loading");
      });
      containerDesktop.forEach((element) => {
        element.innerHTML = count;
        element.classList.remove("loading");
      });
    }

    static renderFilters(html, event) {
      const parsedHTML = new DOMParser().parseFromString(html, "text/html");

      const facetDetailsElements = parsedHTML.querySelectorAll(
        "#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter"
      );
      const matchesIndex = (element) => {
        const jsFilter = event ? event.target.closest(".js-filter") : undefined;
        return jsFilter
          ? element.dataset.index === jsFilter.dataset.index
          : false;
      };
      const facetsToRender = Array.from(facetDetailsElements).filter(
        (element) => !matchesIndex(element)
      );
      const countsToRender =
        Array.from(facetDetailsElements).find(matchesIndex);

      facetsToRender.forEach((element) => {
        document.querySelector(
          `.js-filter[data-index="${element.dataset.index}"]`
        ).innerHTML = element.innerHTML;
      });

      FacetFiltersForm.renderActiveFacets(parsedHTML);
      FacetFiltersForm.renderAdditionalElements(parsedHTML);

      if (countsToRender)
        FacetFiltersForm.renderCounts(
          countsToRender,
          event.target.closest(".js-filter")
        );
    }

    static renderActiveFacets(html) {
      const activeFacetElementSelectors = [
        ".active-facets-mobile",
        ".active-facets-desktop",
      ];

      activeFacetElementSelectors.forEach((selector) => {
        const activeFacetsElement = html.querySelector(selector);
        if (!activeFacetsElement) return;
        document.querySelector(selector).innerHTML =
          activeFacetsElement.innerHTML;
      });

      FacetFiltersForm.toggleActiveFacets(false);
    }

    static renderAdditionalElements(html) {
      const mobileElementSelectors = [
        ".mobile-facets__open",
        ".mobile-facets__count",
        ".sorting",
      ];

      mobileElementSelectors.forEach((selector) => {
        if (!html.querySelector(selector)) return;
        document.querySelector(selector).innerHTML =
          html.querySelector(selector).innerHTML;
      });

      document
        .getElementById("FacetFiltersFormMobile")
        .closest("menu-drawer")
        .bindEvents();
    }

    static renderCounts(source, target) {
      const targetElement = target.querySelector(".facets__selected");
      const sourceElement = source.querySelector(".facets__selected");

      if (sourceElement && targetElement) {
        target.querySelector(".facets__selected").outerHTML =
          source.querySelector(".facets__selected").outerHTML;
      }
    }

    static updateURLHash(searchParams) {
      history.pushState(
        { searchParams },
        "",
        `${window.location.pathname}${searchParams && "?".concat(searchParams)}`
      );
    }

    static getSections() {
      return [
        {
          section: document.getElementById("product-grid").dataset.id,
        },
      ];
    }

    onSubmitHandler(event) {
      event.preventDefault();

      const mergeWithForm = this.dataset.joinWithFacetsFormId
        ? document
            .getElementById(this.dataset.joinWithFacetsFormId)
            ?.querySelector("form")
        : null;
      const mergeWithFormData = mergeWithForm
        ? new FormData(mergeWithForm)
        : null;

      const formData = new FormData(event.target.closest("form"));

      // Merge mergeWithFormData and formData
      if (mergeWithFormData) {
        for (var pair of mergeWithFormData.entries()) {
          formData.append(pair[0], pair[1]);
        }
      }

      const debugParams = {};

      for (var pair of formData.entries()) {
        debugParams[pair[0]] = pair[1];
      }

      const searchParams = new URLSearchParams(formData).toString();

      FacetFiltersForm.renderPage(searchParams, event);
    }

    onActiveFilterClick(event) {
      event.preventDefault();
      FacetFiltersForm.toggleActiveFacets();
      const url =
        event.currentTarget.href.indexOf("?") == -1
          ? ""
          : event.currentTarget.href.slice(
              event.currentTarget.href.indexOf("?") + 1
            );
      FacetFiltersForm.renderPage(url);
    }
  }

  FacetFiltersForm.filterData = [];
  FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
  FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
  customElements.define("facet-filters-form", FacetFiltersForm);
  FacetFiltersForm.setListeners();

  class PriceRange extends HTMLElement {
    constructor() {
      super();
      this.querySelectorAll("input").forEach((element) =>
        element.addEventListener("change", this.onRangeChange.bind(this))
      );

      this.setMinAndMaxValues();
      this.buildSlider();
    }

    buildSlider() {
      const slider = this.querySelector("[data-price-range-slider]");
      const minPrice = 0;
      let maxPrice;
      let currentMaxValue;
      let currentMinValue;

      try {
        maxPrice = parseFloat(slider.dataset.maxPriceInRange);
      } catch (error) {
        maxPrice = 1000;
      }

      try {
        currentMinValue = parseFloat(slider.dataset.minValue);
      } catch (error) {
        currentMinValue = minPrice;
      }

      try {
        currentMaxValue = parseFloat(slider.dataset.maxValue);
      } catch (error) {
        currentMaxValue = maxPrice;
      }

      const range = {
        min: minPrice,
        max: maxPrice,
      };

      noUiSlider.create(slider, {
        start: [currentMinValue, currentMaxValue],
        step: 1,
        tooltips: [
          wNumb({ decimals: 0, prefix: "$" }),
          wNumb({ decimals: 0, prefix: "$" }),
        ],
        connect: true,
        range,
      });

      this.enabled = false;

      slider.noUiSlider.on("start", () => {
        this.enabled = true;
      });

      slider.noUiSlider.on("update", () => {
        const sliderTrigger = Date.now();
        this.lastSliderTrigger = sliderTrigger;

        if (this.enabled) {
          const [minValue, maxValue] = slider.noUiSlider.get();
          const minInput = this.querySelector(".field__input--min-value");
          const maxInput = this.querySelector(".field__input--max-value");
          minInput.value = minValue;
          maxInput.value = maxValue;
          minInput.dispatchEvent(new Event("change"));
          maxInput.dispatchEvent(new Event("change"));

          const form = this.closest("form");
          form.dispatchEvent(new Event("input"));
        }
      });
    }

    onRangeChange(event) {
      this.adjustToValidValues(event.currentTarget);
      this.setMinAndMaxValues();
    }

    setMinAndMaxValues() {
      const inputs = this.querySelectorAll("input");
      const minInput = inputs[0];
      const maxInput = inputs[1];
      if (maxInput.value) minInput.setAttribute("max", maxInput.value);
      if (minInput.value) maxInput.setAttribute("min", minInput.value);
      if (minInput.value === "") maxInput.setAttribute("min", 0);
      if (maxInput.value === "")
        minInput.setAttribute("max", maxInput.getAttribute("max"));
    }

    adjustToValidValues(input) {
      const value = Number(input.value);
      const min = Number(input.getAttribute("min"));
      const max = Number(input.getAttribute("max"));

      if (value < min) input.value = min;
      if (value > max) input.value = max;
    }
  }

  customElements.define("price-range", PriceRange);

  class FacetRemove extends HTMLElement {
    constructor() {
      super();
      this.querySelector("a").addEventListener("click", (event) => {
        event.preventDefault();
        const form =
          this.closest("facet-filters-form") ||
          document.querySelector("facet-filters-form");
        form.onActiveFilterClick(event);
      });
    }
  }

  customElements.define("facet-remove", FacetRemove);
}
